__turbopack_context__.v({
  "cancelButton": "styles-module-scss-module__PfKw2W__cancelButton",
  "caption": "styles-module-scss-module__PfKw2W__caption",
  "formFooter": "styles-module-scss-module__PfKw2W__formFooter",
});
